import React from 'react';

export default function SceneGrid({ visible }) {
  if (!visible) return null;
  return <gridHelper args={[4000, 80, '#eab308', '#7c5a10']} position={[0, 0, 0]} />;
}
